package one.healthium.ui.compose.components

import androidx.compose.foundation.layout.offset
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.utils.TargetPlatform
import one.healthium.ui.compose.utils.targetPlatform
import org.jetbrains.compose.resources.painterResource

@Composable
fun AppBackNavigationButton(
    modifier: Modifier = Modifier,
    onClick: () -> Unit,
) {
    val modifier = when (targetPlatform()) {
        TargetPlatform.Android -> modifier
        TargetPlatform.IOS -> modifier.offset(x = -(8.dp))
        TargetPlatform.Web -> modifier
    }
    IconButton(
        modifier = modifier,
        onClick = onClick
    ) {
        Icon(
            painter = painterResource(AppIcons.icNavigationBack),
            contentDescription = null,
        )
    }
}